module.exports = __webpack_public_path__ + "static/media/s1.94983682.png";